// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"sK-z","smallCardRow":"tK-z","largeCardRow":"uK-z","productSearchRow":"vK-z","curatedRow":"wK-z"};